import type { TFilterNavigationState, TNavigationType, TPageKey, TPendingTransfer, TSavedPageFilters } from './types';

export const setNavigationType = (state: TFilterNavigationState, type: TNavigationType): void => {
  state.lastNavigationType = type;
};

export const setPendingTransfer = (state: TFilterNavigationState, payload: TPendingTransfer): void => {
  state.pendingTransfer = payload;
};

export const clearPendingTransfer = (state: TFilterNavigationState): void => {
  state.pendingTransfer = null;
};

export const setPageFilters = (
  state: TFilterNavigationState,
  payload: { pageKey: TPageKey; filters: TSavedPageFilters },
): void => {
  state.savedFilters[payload.pageKey] = payload.filters;
};

export const pushRoute = (state: TFilterNavigationState, path: string): void => {
  state.routeHistory = [...state.routeHistory.slice(-1), path];
};
